import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

interface IMessageData {
  messageInput: string | null;
  activityId: string | null;
  receiverId: string | null;
}

const initialState: {
  userCreateMessageData: any;
  userCreateMessageLoading: boolean;
  userCreateMessageError: SerializedError | null;
} = {
  userCreateMessageData: {},
  userCreateMessageLoading: false,
  userCreateMessageError: null,
};

export const userCreateMessageFunc = createAsyncThunk(
  'userCreateMessage/userCreateMessageFunc',
  async (values: {
    activityId: null | string;
    receiverId: null | string;
    messageInput: {
      content: string;
      attachments: string[];
    };
  }) => {
    const accessTokenJSON = localStorage.getItem('auth');
    const data1 = JSON.stringify({
      query: `mutation UserCreateMessage($activityId: String!, $receiverId: String!, $messageInput: MessageInput!) {
        user_createMessage(activityId: $activityId, receiverId: $receiverId, messageInput: $messageInput) {
            _id
        }
    }`,
      variables: {
        activityId: values.activityId,
        receiverId: values.receiverId,
        messageInput: values.messageInput,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userCreateMessage = createSlice({
  name: 'userCreateMessage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userCreateMessageFunc.pending, (state) => {
      state.userCreateMessageLoading = true;
    });
    builder.addCase(userCreateMessageFunc.fulfilled, (state, action) => {
      state.userCreateMessageLoading = false;
      state.userCreateMessageData = action.payload?.data?.userCreateMessage;
      state.userCreateMessageError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userCreateMessageFunc.rejected, (state, action) => {
      state.userCreateMessageLoading = false;
      state.userCreateMessageError = action.error;
    });
  },
});

export default userCreateMessage.reducer;
